<template>
  <div>
    <div class="children-wrap">
      <van-row type="flex" justify="space-between" align="center">
        <van-col>
          <div v-for="(child, i) in childData" :key="i" class="avatar-box fl mr-15" @click="showSwitch">
            <van-image
              round
              :src="child.avatar"
              :class="{'active': child.id==current.id}"
              class="avatar-1" />
              <van-icon name="checked" color="#4D88D2" class="icon-1" v-if="child.id==current.id" />
            </div>
        </van-col>
        <van-col v-if="childData.length>0" class="font14">
          {{ current.className }}
        </van-col>
      </van-row>
    </div>
    <van-action-sheet
      v-model="show"
      :cancel-text="$t('global.cancel')"
      close-on-click-action>
        <van-row type="flex" justify="space-between" align="center" class="van-action-sheet__item"
        v-for="(child, i) in childData" :key="i"
        @click="switchChild(child)">
          <van-col>
            <van-image
              round
              :src="child.avatar"
              class="avatar-1 mr-10" />
            {{ child.name }}
          </van-col>
          <van-col>
            <van-icon name="success" color="#4E89D3" v-if="child.id==current.id" />
          </van-col>
        </van-row>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from 'vue';
import { Col, Row, Image as VanImage, ActionSheet } from 'vant';
import storage from 'store'
import { CURRENT_CHILD } from '@/store/mutation-types'
import { childList } from '@/api/child'
import i18n from '../i18n'

Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);
Vue.use(ActionSheet);

export default {
  name: 'Children',
  props: {
    children: Array
  },
  data() {
    return {
      childData: [],
      current: {},
      show: false,
    }
  },
  watch: {
    children(val) {
      this.childData = val
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData() {
      if (this.children) {
        this.childData = this.children
        this.handChild()
      }
      else {
        childList().then(res => {
          this.childData = res.data
          this.handChild()
        })
      }
    },
    showSwitch() {
      if (this.childData.length>1) {
        this.show = true
      }
    },
    handChild() {
      let hasChild = false
      let queryChild = -1
      let cChild = storage.get(CURRENT_CHILD + i18n.locale) || this.childData[0]
      this.childData.map((item, index) => {
        if (cChild.id == item.id) {
          hasChild = true
          if (item.className != cChild.className) {
            cChild.className = item.className
          }
        }
        if (this.$route.query.childid == item.id) {
          queryChild = index
        }
      })
      if (queryChild > -1) {
        this.current = this.childData[queryChild]
      }
      else if (hasChild) {
        this.current = cChild
      }
      else {
        this.current = this.childData[0]
      }
      
      this.switchChild(this.current)
    },
    switchChild(obj) {
      this.current = obj;
      storage.set(CURRENT_CHILD + i18n.locale, this.current)
      this.$emit('change', this.current)
      this.show = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.children-wrap {
  padding: 0 15px;
  height: 52px;
  line-height: 52px;
  background: #FFFFFF;
  .active {
    border: 2px solid #4D88D2;
  }
  .avatar-box {
    width: 36px;
    position: relative;
    .van-icon {
      position: absolute;
      bottom: 6px;
      right: -7px;
    }
  }
}
.avatar-1 {
  vertical-align: middle;
  width: 30px;
  height: 30px;
}
.icon-1::before {
  font-size: 12px;
}
.van-action-sheet__item {
  display: flex;
  width: auto;
  text-align: left;
  border-bottom: 1px solid #EBEDF0;
  font-weight: 400;
  color: #323233;
}
.van-action-sheet__item:last-child {
 border-bottom: 0;
}
</style>
